import React, { FC } from 'react';
import {
  QUESTIONNAIRE_SECTION_COLORS,
  BRAND_MID,
} from '../tokens/colors';

interface QuestionnaireProgressHeaderProps {
  currentQuestion: { secIdx: number; secTitle: string }
  totalParts: number
  questionIndex: number
  totalQuestions: number
  sectionColor: string
  partLabels: string[]
  parts: { color?: string }[]
}

const QuestionnaireProgressHeader: FC<QuestionnaireProgressHeaderProps> = ({
  currentQuestion, totalParts, questionIndex, totalQuestions, sectionColor, partLabels, parts,
}) => (
  <div className="bg-white border-b border-slate-200 px-4 py-3 flex-shrink-0 shadow-sm sticky top-0 z-10">
    <div className="max-w-content mx-auto">
      <div className="flex items-center justify-between mb-2">
        <span
          className="text-xs font-bold px-3 py-1 rounded-full text-white"
          style={{ background: sectionColor }}
        >
          Section
          {' '}
          {currentQuestion.secIdx + 1}
          /
          {totalParts}
          {' · '}
          {currentQuestion.secTitle}
        </span>
        <span className="text-xs font-bold text-slate-400">
          {questionIndex + 1}
          {' / '}
          {totalQuestions}
        </span>
      </div>
      <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${((questionIndex + 1) / totalQuestions) * 100}%`,
            background: sectionColor,
          }}
        />
      </div>
      <div className="flex gap-1.5 mt-2.5 flex-wrap">
        {partLabels.map((label, idx) => {
          const isDone = currentQuestion.secIdx > idx;
          const isActive = currentQuestion.secIdx === idx;
          const pillColor = parts[idx]?.color
            || QUESTIONNAIRE_SECTION_COLORS[idx % QUESTIONNAIRE_SECTION_COLORS.length];
          let pillBg = '#f1f5f9';
          if (isDone) pillBg = '#dbeafe';
          else if (isActive) pillBg = pillColor;
          let pillTextColor = '#94a3b8';
          if (isDone) pillTextColor = BRAND_MID;
          else if (isActive) pillTextColor = 'white';
          return (
            <div
              key={label}
              className="text-xs font-semibold px-2.5 py-0.5 rounded-full"
              style={{ background: pillBg, color: pillTextColor }}
            >
              {isDone ? '✓ ' : ''}
              {label}
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

export default QuestionnaireProgressHeader;
